import { useState } from 'react';
import NavBar from '../components/common/NavBar';
import NewHeaderComponent from '../components/common/NewHeaderComponent';
import DoctorFilterStripUi from '../components/multiDocComponents/DoctorStrip';
import { getDoctorSelectorList } from '../store/idbHandler';
import EditTemplate from './editTemplate/EditTemplate';

export default function MyRXTemplate() {
    const doctors = getDoctorSelectorList();

    const [selectedDocid, setSelectedDocid] = useState(() => doctors?.[0].id);

    return (
        <div className="grid h-full overflow-x-auto overflow-y-hidden grid-cols-queueGrid min-w-840 undefined">
            <NavBar />
            <div className="flex flex-col h-full col-span-11 overflow-hidden">
                <NewHeaderComponent title="My Rx Template" />

                {doctors.length > 1 ? (
                    <div className="flex space-x-4 overflow-x-scroll w-full px-16">
                        {doctors?.map((doc) => (
                            <DoctorFilterStripUi
                                key={doc.id}
                                doctorName={`Dr. ${doc.personal.name.f || ''} ${
                                    doc.personal.name.l || ''
                                }`.trim()}
                                doctorPic={doc.personal.pic}
                                onClick={() => {
                                    setSelectedDocid(doc.id);
                                }}
                                showAptCount={false}
                                isSelected={selectedDocid === doc.id}
                            />
                        ))}
                    </div>
                ) : null}

                <EditTemplate key={selectedDocid} docid={selectedDocid} />
            </div>
        </div>
    );
}
